import { render, staticRenderFns } from "./ProductionFacility.vue?vue&type=template&id=7db09827"
import script from "./ProductionFacility.vue?vue&type=script&lang=js"
export * from "./ProductionFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports